<template>
    <b-col cols="auto">
        <b-row>
            <b-col cols="auto" class="form-inline pt-3">
                <label class="mr-sm-2">Search date from:</label>
                <date-pick
                    v-model="date.from"
                    :displayFormat="'DD/MM/YYYY'"
                    :inputAttributes="{placeholder: 'dd/mm/yyyy', class: `form-control ${fieldValid}`}"
                ></date-pick>
                <button class="btn btn-close text-red" @click="date.from = ''">&times;</button>
            </b-col>
            <b-col cols="auto" class="form-inline pt-3">
                <label class="mr-sm-2">Search date to:</label>
                <date-pick
                    v-model="date.to"
                    :displayFormat="'DD/MM/YYYY'"
                    :inputAttributes="{placeholder: 'dd/mm/yyyy', class: `form-control ${fieldValid}`}"
                ></date-pick>
                <button class="btn btn-close text-red" @click="date.to = ''">&times;</button>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    import DatePick from 'vue-date-pick'
    export default {
        name: 'DateFilters',
        data() {
            return {
                search: '',
                date: {
                    from: this.$route.query['filter[createdAt:from]'] ? this.$route.query['filter[createdAt:from]'] : '',
                    to: this.$route.query['filter[createdAt:to]'] ? this.$route.query['filter[createdAt:to]'] : ''
                },
                error: false
            }
        },
        computed: {
            fieldValid() {
                return this.error ? 'is-invalid' : ''
            }
        },
        components: {
            DatePick
        },
        methods: {
            dateFromAction(payload) {
                this.inputValidation()
                if (!this.error) {
                    this.$emit('dateFromAction', {'createdAt:from': payload})
                }
            },
            dateToAction(payload) {
                this.inputValidation()
                if (!this.error) {
                    this.$emit('dateToAction', {'createdAt:to': payload})
                }
            },
            inputValidation() {
                let from = Date.parse(this.date.from)
                let to = Date.parse(this.date.to)
                if (from > to) {
                    this.error = true
                    this.$store.dispatch('globalAlertAction', {
                        type: 'error',
                        title: 'Not valid filter',
                        timeout: 10000
                    })
                    return false
                } else {
                    this.error = false
                }
            }
        },
        watch: {
            'date.from': {
                handler(newValue) {
                    if (/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(newValue) || newValue === '') {
                        this.dateFromAction(newValue)
                    }
                },
                deep: true
            },
            'date.to': {
                handler(newValue) {
                    if (/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(newValue) || newValue === '') {
                        this.dateToAction(newValue)
                    }
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/style/utils/_variables.scss";
    $vdpColor: $accent-color-user;
    @import 'vue-date-pick/src/vueDatePick.scss';
    @import 'vue-date-pick/dist/vueDatePick.css';
    .vdpClearInput{
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/DateFilters.vue